import React, {ReactElement} from 'react';
import {useIntl} from 'react-intl';

import CardLink from '../CardLink/CardLink';
import {Locale, useLocale} from '../../../RootProvider/LocaleContext';
import {ReactComponent as BusinessLoansIcon} from '../../../images/icons/handHoldingCoinYellowShadow.svg';
import {ReactComponent as InvoiceFinanceIcon} from '../../../images/icons/invoiceYellowShadow.svg';
import {ReactComponent as AssetFinanceIcon} from '../../../images/icons/vanYellowShadow.svg';
import {ReactComponent as PropertyDevelopmentIcon} from '../../../images/icons/industryYellowShadow.svg';
import {ReactComponent as CommercialMortgagesIcon} from '../../../images/icons/storeYellowShadow.svg';
import {ReactComponent as WorkingCapitalIcon} from '../../../images/icons/exchangingCoinsYellowShadow.svg';
import {ReactComponent as BusinessCreditCardsIcon} from '../../../images/icons/creadiCardMagneticStripeYellowShadow.svg';

import './OurProducts.scss';

function OurProductsLinks(): ReactElement {
  const locale = useLocale();
  const {formatMessage} = useIntl();

  return (
    <div className="ourProducts__links">
      <CardLink
        className="ourProducts__button"
        href={formatMessage({id: 'homepage.ourProducts.links.businessLoans.href'})}
        icon={<BusinessLoansIcon />}
        label={formatMessage({id: 'homepage.ourProducts.links.businessLoans.text'})}
        compact
      />
      <CardLink
        className="ourProducts__button"
        href={formatMessage({id: 'homepage.ourProducts.links.invoiceFinance.href'})}
        icon={<InvoiceFinanceIcon />}
        label={formatMessage({id: 'homepage.ourProducts.links.invoiceFinance.text'})}
        compact
      />
      <CardLink
        className="ourProducts__button"
        href={formatMessage({id: 'homepage.ourProducts.links.assetFinance.href'})}
        icon={<AssetFinanceIcon />}
        label={formatMessage({id: 'homepage.ourProducts.links.assetFinance.text'})}
        compact
      />
      <CardLink
        className="ourProducts__button"
        href={formatMessage({id: 'homepage.ourProducts.links.propertyDevelopment.href'})}
        icon={<PropertyDevelopmentIcon />}
        label={formatMessage({id: 'homepage.ourProducts.links.propertyDevelopment.text'})}
        compact
      />
      {![Locale.nl].includes(locale) && (
        <CardLink
          className="ourProducts__button"
          href={formatMessage({id: 'homepage.ourProducts.links.commercialMortgages.href'})}
          icon={<CommercialMortgagesIcon />}
          label={formatMessage({id: 'homepage.ourProducts.links.commercialMortgages.text'})}
          compact
        />
      )}
      <CardLink
        className="ourProducts__button"
        href={formatMessage({id: 'homepage.ourProducts.links.workingCapital.href'})}
        icon={<WorkingCapitalIcon />}
        label={formatMessage({id: 'homepage.ourProducts.links.workingCapital.text'})}
        compact
      />
      <CardLink
        className="ourProducts__button"
        href={formatMessage({id: 'homepage.ourProducts.links.businessCards.href'})}
        icon={<BusinessCreditCardsIcon />}
        label={formatMessage({id: 'homepage.ourProducts.links.businessCards.text'})}
        compact
      />
    </div>
  );
}

export default OurProductsLinks;
